import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { subscribersTabs } from './helpers/index';

const SubscribersTabs = () => <Tabs tabs={subscribersTabs} />;

export default SubscribersTabs;
